import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const Clock = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M24.9792 4.16669C13.4792 4.16669 4.16675 13.5 4.16675 25C4.16675 36.5 13.4792 45.8334 24.9792 45.8334C36.5001 45.8334 45.8334 36.5 45.8334 25C45.8334 13.5 36.5001 4.16669 24.9792 4.16669ZM25.0001 41.6667C15.7917 41.6667 8.33341 34.2084 8.33341 25C8.33341 15.7917 15.7917 8.33335 25.0001 8.33335C34.2084 8.33335 41.6667 15.7917 41.6667 25C41.6667 34.2084 34.2084 41.6667 25.0001 41.6667ZM26.0417 14.5834H22.9167V27.0834L33.8542 33.6459L35.4167 31.0834L26.0417 25.5209V14.5834Z"
        fill={color}
      />
    </svg>
  )
}
